export const USER_CHANGED_INPUT_TEXT = 'wdcr/user/changed_input_text';
export const USER_CLICKED_COPY_BUTTON = 'wdcr/user/clicked_copy_button';
export const USER_CLICKED_DELETE_TEXT = 'wdcr/user/clicked_delete_text';
export const USER_PASTED_TEXT = 'wdcr/user/pasted_text';
